export enum NotificationType {
    WARNING = "WARNING",
    SUCCESS = "SUCCESS",
    INFO = "INFO",
    ERROR = "ERROR"
}

export interface Notification {
  type: NotificationType;
  message: string;
  timestamp: number;
}

export interface NotificationState {
  notifications: Notification[];
}